export default "__VITE_ASSET__9cc52fe8__"